import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription }   from 'rxjs/Subscription';
import { MenuStatus, Menu } from '../../models/Menu';
import { Subject } from 'rxjs/Subject';
import { MenuService } from '../../services/MenuService';
import { UserService } from '../../../user/services/UserService';
import { SessionService } from '../../../user/services/SessionService';
import { User } from '../../../user/models/User';
import { Router } from '@angular/router';
import { HolidayService } from '../../../../../holiday/services/HolidayService';
import { SessionStorageService } from '../../services';
import { AdminService } from '../../../../../common/modules/admin/services/AdminService';
@Component({
    selector: 'main-menu',
    template: require('./MainMenuComponent.html'),
    styles: [require('./MainMenuComponent.sass')],
})

export class MainMenuComponent implements OnInit, OnDestroy {
    @Input() module: string;
    private menuList: Menu[];
    private subMenuList: Menu[];
    private parent: any;
    message:        string;
    messageType:    string;
    private userData: User;
	private hostName: string;
    private menuStatus: boolean;
    private menuStatusChanged = new Subject<boolean>();
    private subscription: Subscription;
    private menuSubscription: Subscription;
    private userMenuClassVisible = 'menu-list-visible';
    protected devEnv: any = ['services.eca.dev.nascorp.vn','camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn', 'conference.eca.dev.nascorp.vn'];
    protected testEnv: any = ['services.eca.test.nascorp.vn','camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn', 'conference.eca.test.nascorp.vn'];
    protected stagingEnv: any = ['auth.eca.uat.nascorp.vn','services.eca.uat.nascorp.vn','asa.eca.uat.nascorp.vn','holidayschool.eca.uat.nascorp.vn','bus.eca.uat.nascorp.vn','outdooreducation.eca.uat.nascorp.vn','reen.eca.uat.nascorp.vn','acs.eca.uat.nascorp.vn','pcbs.eca.uat.nascorp.vn'];
    protected procEnv: any = ['services.aisvietnam.com','outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com', 'pcbs.aisvietnam.com']
    constructor(
        private menuService: MenuService,
        private router: Router,
        private holidayService: HolidayService,
        private userService: UserService,
        private sessionService: SessionService,
        private sessionStorageService: SessionStorageService,
        private adminService: AdminService
    ) {
    }
    
    ngOnInit() { 
        this.parent = new Object;     
        this.getSessionData()
        this.hostName = window.location.hostname;
        
        // Get main menu List
        this.menuList = this.getMainMenuList();
        //  Get sub menu list
        this.subMenuList = this.getSubMenuList();
        
        this.menuStatus = this.getMenuStatus();
        // Subscription to catch the session changed to change the menu list content
        this.subscription = this.userService.userDataChanged$.subscribe(
            user => {
                this.onSessionChanged(user);
            }
        );
    }

    checkAccountIsAisParent(){
        return this.sessionStorageService.getData<boolean>('isAisParent');
    }

    ngOnDestroy() {
        // Destroy the subscription for session changes
        this.subscription.unsubscribe();
    }

    /**
     * Action that fired when the session change event is catched.
     * Update the userData & the menuList.
     */
    private onSessionChanged(user: User) {
        //TO DO: update menu content when session changed
        this.userData = user;
        // Get Menu List
        this.menuList = this.getMainMenuList();
        this.subMenuList = this.getSubMenuList();
    }

    private onMenuStatusChanged() {
        this.menuStatus = this.getMenuStatus();
    }

    private getMenuStatus() {
        if( document.URL === 'http://services.eca.dev.nascorp.vn/' ||
            document.URL === 'http://services.local.eca.dev.nascorp.vn/' ||
            document.URL === 'http://services.eca.test.nascorp.vn/' ||
            document.URL === 'http://services.eca.uat.nascorp.vn/' ||
            document.URL === 'https://services.aisvietnam.com/'
        ) {
            return false
        }
        else {
            return true
        }
    }

    /**
     * Return a module 's menu list content for the main menu.
     * Return login main menu list if no user data is detected.
     * @returns {Menu[]|[]} - module's menu list or empty list.
     */
    private getMainMenuList() {
        let menuList: Menu[] = [];
        if(!this.userData && (this.hostName === "holidayschool.aisvietnam.com"
            || this.hostName === "holiday.eca.dev.nascorp.vn"
            || this.hostName === "holiday.local.eca.dev.nascorp.vn"
            || this.hostName === "holiday.eca.test.nascorp.vn"
            || this.hostName === "holidayschool.eca.uat.nascorp.vn")            ) 
        {
            menuList = this.menuService.getMenuList('hol-login')
        }

        else if(!this.userData) {
            menuList = this.menuService.getMenuList('login-main');
        }
        else {
            menuList = this.menuService.getMenuList(this.module + '-main');
        }

        return menuList;
    }

    /**
     * Return a module 's SUB menu list content for the main menu.
     * Return login main menu list if no user data is detected.
     * @returns {Menu[]|[]} - module's menu list or empty list.
     */
    private getSubMenuList() {
        return this.menuService.getMenuList(this.module + '-sub');
    }

    toLogOut() {
        this.userData = this.userService.getUserSessionData();
        this.deleteSession();
    }
        /**
     * Delete user session data.
     */

    private deleteSession() {
        this.sessionService.deleteSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.userService.clearUserSessionData();
                    this.adminService.clearInterSession();

                    // Fire user session data changed event
                    this.userService.userDataChanged(null);

                    // Redirect to desired URL                    
                    if(this.devEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.dev.nascorp.vn';
                    }
                    else if(this.testEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.test.nascorp.vn';
                    }
                    else if(this.stagingEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.uat.nascorp.vn';
                    }
                    else if(this.procEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'https://services.aisvietnam.com';
                    }
                    else{
                        return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
                    }
                },
            );
    }

    getSessionData() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userData = user
                    
                    if(this.userData.role !== 'system' && this.userData.role !== 'manager') {
                        this.getParent();
                    }
                        
                }
            )
    }

    toHomePage() {
        // Redirect to desired URL
        if(this.userData.role === 'parent' || this.parent.type === 'ais'){                   
            if(this.devEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'http://services.eca.dev.nascorp.vn/parents';
            }
            else if(this.testEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'http://services.eca.test.nascorp.vn/parents';
            }
            else if(this.stagingEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'http://services.eca.uat.nascorp.vn/parents';
            }
            else if(this.procEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'https://services.aisvietnam.com/parents';
            }
            else{
                return window.location.href = 'http://services.local.eca.dev.nascorp.vn/parents';
            }
        } 
        // Redirect to desired URL
        if(this.userData.role === 'hol-parent' || this.parent.type === 'other'){                   
            if(this.devEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'http://services.eca.dev.nascorp.vn/other-parents';
            }
            else if(this.testEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'http://services.eca.test.nascorp.vn/other-parents';
            }
            else if(this.stagingEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'http://services.eca.uat.nascorp.vn/other-parents';
            }
            else if(this.procEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'https://services.aisvietnam.com/other-parents';
            }
            else{
                return window.location.href = 'http://services.local.eca.dev.nascorp.vn/other-parents';
            }
        } 
        if(!this.userData && !this.parent){                   
            if(this.devEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'http://services.eca.dev.nascorp.vn';
            }
            else if(this.testEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'http://services.eca.test.nascorp.vn';
            }
            else if(this.stagingEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'http://services.eca.uat.nascorp.vn';
            }
            else if(this.procEnv.indexOf(this.hostName) !== -1){
                return window.location.href = 'https://services.aisvietnam.com';
            }
            else{
                return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
            }
        } 
    }

    toRegister() {
        if(this.hostName === "holidayschool.aisvietnam.com"
            || this.hostName === "holiday.eca.dev.nascorp.vn"
            || this.hostName === "holiday.local.eca.dev.nascorp.vn") 
        {
            this.router.navigateByUrl('/hol-register');
        }
        else {
            this.router.navigate(['/register'])
        }
    }

    toChangePassword() {
        if(this.hostName === "holidayschool.aisvietnam.com"
            || this.hostName === "holiday.eca.dev.nascorp.vn"
            || this.hostName === "holiday.local.eca.dev.nascorp.vn") 
        {
            this.router.navigateByUrl('/hol-change-password');
        }
        else {
            this.router.navigate(['/change-password'])
        }
    }
    menuStatusDataChanged(menu: boolean) {
        this.menuStatusChanged.next(menu);
    }

    private getParent() {
        this.holidayService.getParent()
            .subscribe(
                (parent:any) => {
                    this.parent = parent;

                    if(this.parent.status === "fill-info") {
                        this.router.navigate(['/profile/add-parent'])
                    }
                    else if(this.parent.status == "full") {
                        this.router.navigate(['/booking/students'])
                    }
                    else {
                        this.router.navigate(['/add-student'])
                       
                    }
                },
                (error:any) => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    toProfile(){
        if (this.hostName === "holidayschool.aisvietnam.com"
            || this.hostName === "holiday.eca.dev.nascorp.vn"
            || this.hostName === "holiday.local.eca.dev.nascorp.vn") {
            this.router.navigateByUrl('/profile/edit-parent');
        }
        else {
            this.router.navigate(['/profile/edit-parent'])
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/modules/core/components/main-menu/MainMenuComponent.ts